import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import React from 'react'
import {renderIf} from 'views/Shared'
import {ImagePlaceholder} from "../../../conts/imageBase64";
import {renderIfElse} from "../../Shared";
import {PiCertificate} from "react-icons/pi";
import {ItemInformation} from 'components/common/ItemInformation'
import {Image} from "antd";

const renderMedal = ({translate: t, isLg, renderContextMenu } = {}) => (item, index) => {

    const tags = Array.from(item?.tags ?? [])

    return (
        <div key={index} className="p-4 flex flex-col md:flex-row gap-2 md:gap-3 custom-item-render relative list-item">
            {renderIfElse(
                item?.avatar,
                <Image
                    preview={false}
                    src={item?.avatar}
                    fallback={ImagePlaceholder}
                    style={{ width: isLg ? 120 : '100%', height: 120}}
                    className="rounded-xl object-cover bg-no-repeat"
                    wrapperStyle={{ width: isLg ? 120 : '100%' }}
                    wrapperClassName="rounded-xl"
                />,
                <div style={{ width: isLg ? 120 : '100%', height: 120 }} className="flex flex-center background-200 rounded-xl">
                    <PiCertificate size={60} style={{color: '#dddddd'}}/>
                </div>
            )}
            <div className="flex flex-col flex-1 relative">
                <h2 className="font-bold text-lg text-color-000 tracking-wide max-lines-1">
                    {getTitle(item)}
                </h2>
                <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-1">
                    <ItemInformation showIcon={false} label="level" value={item?.lvl_number} className="tracking-wider"/>
                    <ItemInformation showIcon={false} label="total_count" value={item?.total_count} className="tracking-wider"/>
                </div>
                <div className="my-1 border-b border-color-50"/>
                {renderIf(
                    tags.length,
                    <ItemInformation showIcon={true} label="tags" value={tags.map(({ tags }) => `#${tags}`).join(', ')} className="italic tracking-wider"/>
                )}
                {item?.description && (
                    <div className="mt-2 text-color-300 tracking-wider max-lines-3">
                        {item?.description}
                    </div>
                )}
                {renderIf(
                    _.isFunction(renderContextMenu) && !isLg,
                    <div className="absolute top-20 right-0 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                )}
            </div>
            {renderIf(
                _.isFunction(renderContextMenu) && isLg,
                <div className="absolute top-8 right-8 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}

export default renderMedal
